import Editor from './Tinymce.vue'
export default Editor



// WEBPACK FOOTER //
// ./src/index.js